module.exports = __webpack_public_path__ + "static/icon-atdw-e3b3f06551ff8fd637ea8b1cc08edb15.svg";